import styled from "styled-components";
import { Alert } from "react-bootstrap";

export const Container = styled.div`
  width: 100%;
  max-width: 1080px;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 7.5rem;
  margin-bottom: 6rem;

  h1 {
    color: #495156;
    text-align: center;
    font-size: 36px;
    font-style: normal;
    font-weight: 700;
    line-height: 16px;
    letter-spacing: 1.8px;
  }
  span {
    font-weight: 400;
  }
`;

export const AlertInfo = styled(Alert)`
  width: 100%;
  max-width: 1080px;

  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #f5af45;
  border-radius: 4px;
  padding: 24px 36px;
  margin-top: 46px;
  margin-bottom: 48px;

  div {
    display: flex;
    align-items: center;
    justify-content: center;

    p {
      margin: 0;
      margin-left: 32px;
      color: #495156;
      font-size: 1rem;
      font-weight: 400;
      line-height: 150%;
    }
  }
`;

export const Form = styled.form`
  width: 100%;

  .required-fields-legend {
    display: flex;
    align-items: center;
    gap: 0.25rem;
    margin-bottom: 1rem;
    color: #495156;
    font-size: 0.95rem;
    line-height: 1.5;
  }

  .form-fields {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 1rem;

    .control {
      margin-bottom: 0;
      justify-content: start;
    }

    .minorAlert {
      margin: 0;
      margin-bottom: 20px;
    }

    .full-width {
      width: 100%;
      grid-column: 1 / span 2;

      .control {
        svg {
          margin: 0;
        }
      }
    }

    button[type="submit"] {
      width: 100%;

      padding: 0 1.5rem;
      height: 2rem;
      margin-top: 1.5rem;
      margin-left: 0.5rem;

      color: #ec1978;
      border-radius: 1.25rem;
      border: 0;
      font-size: 1rem;

      font-weight: 600;

      transition: filter 0.2s;

      &:hover {
        filter: brightness(0.9);
      }
    }
  }
`;

export const Navigation = styled.div`
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: space-between;

  margin-top: 2rem;
  margin-bottom: 2rem;

  button {
    width: 127px;
    height: 45px;
  }
`;

export const ContainerOptionsRadio = styled.div`
  width: 100%;

  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
`;

export const ContainerReceiveAccess = styled.div`
  width: 100%;

  margin-top: 2rem;

  display: flex;
  flex-direction: column;

  label {
    margin: 0;
    margin-bottom: 0 !important;
  }
  div {
    margin-left: 0;
    display: flex;
    align-items: center;
    justify-content: center;

    span {
      margin-right: 0.5rem;
    }
    input[type="radio"] {
      padding: 0.5rem;
      height: 4rem;
      margin-left: 1rem;
    }
  }
  .control {
    justify-content: start;
  }
`;

export const ContainerContactTypes = styled.div`
  width: 100%;

  label {
    margin-left: 0;
    font-weight: 700;
  }
  div {
    margin-left: 0;
    display: block;

    label {
      margin-right: 2.5rem;
      padding-left: 8px;
    }

    input[type="checkbox"] {
      width: 5%;
      height: 22px;
      background: #ec1978;
      color: #ec1978;
    }

    div input[type="checkbox"] {
      width: 3%;
      height: 22px;
      background: #ec1978;
      color: #ec1978;
    }
  }
`;

export const ContainerOptionSendAcceptanceTerm = styled.div`
  width: 100%;

  margin-top: 2rem;

  display: flex;
  flex-direction: column;

  label {
    margin: 0;
    margin-bottom: 0 !important;
  }
  div {
    margin-left: 0;
    display: flex;
    align-items: center;
    justify-content: center;

    span {
      margin-right: 0.5rem;
    }
    input[type="radio"] {
      padding: 0.5rem;
      height: 4rem;
      margin-left: 1rem;
    }
  }
  .control {
    justify-content: start;
    margin-bottom: 0;
  }

  .control:not(:last-child) {
    margin-bottom: 0;
  }
`;
